import { RouteItem } from '@eastcoal/router/types/route'

import { PRICE_COMPARE_SALE_LIST_PAGE_PATH } from './constants/path'

export const priceCompareSaleListRoute: RouteItem = {
  title: '比价采购',
  path: PRICE_COMPARE_SALE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
